import React, { ReactElement } from 'react';
import { connect } from 'react-redux';
import { useGetAllVmTemplatesQuery } from '../../../../redux/templateManager/VmTemplates/api';
import { RootState } from '../../../../redux/store';
import {
  setSelectedInventoryItem,
  templateManagerSelectors,
} from '../../../../redux/templateManager/slice';
import { getVisibilityFilters } from '../../../../redux/templateFilters/slice';
import { TableLoader } from '../../../../components/Table/TableLoader';
import { prepTemplatedVmsForTable } from './utils';
import { VmTemplates } from '.';

function ManageVmTemplatesContainer({
  selectedDatacenter,
  selectedInventoryItem,
  selectedVisibilityFilters,
  setSelectedInventoryItem,
}: ManageVmTemplatesContainerProps): ReactElement {
  const { isFetching, isLoading, isError, transformedTemplateVms } =
    useGetAllVmTemplatesQuery(selectedDatacenter!, {
      selectFromResult: ({ data, isLoading, isFetching, isError }) => ({
        data,
        isError,
        isFetching,
        isLoading,
        transformedTemplateVms: data
          ? prepTemplatedVmsForTable(data)
          : undefined,
      }),
    });

  if (!transformedTemplateVms || isLoading || isFetching || isError) {
    return <TableLoader />;
  }

  return (
    <VmTemplates
      isLoading={isLoading || isFetching || isError}
      selectedInventoryItem={selectedInventoryItem}
      setSelectedInventoryItem={setSelectedInventoryItem}
      visibilityFilters={selectedVisibilityFilters}
      vmTemplates={transformedTemplateVms || []}
    />
  );
}

const mapStateToProps = (state: RootState) => ({
  selectedDatacenter: templateManagerSelectors.getSelectedDataCenter(state),
  selectedInventoryItem:
    templateManagerSelectors.getSelectedInventoryItem(state),
  selectedVisibilityFilters: getVisibilityFilters(state),
});

const mapDispatchToProps = {
  setSelectedInventoryItem,
};

export type ManageVmTemplatesContainerProps = ReturnType<
  typeof mapStateToProps
> &
  typeof mapDispatchToProps;

export const ConnectedVmTemplates = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManageVmTemplatesContainer);
